import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ModalStackPropsBase } from './ModalStackProvider';

interface IProps extends ModalStackPropsBase<unknown, unknown> {
  show?: boolean;
  onSubmit: () => void;
  onClose?: () => void;
}

export function SomethingWentWrongModal(
  props: React.PropsWithChildren<IProps>,
): React.FunctionComponentElement<IProps> {
  const { t } = useTranslation();
  const { show, onSubmit, onClose } = props;

  const elementID = {
    title: 'something-wrong-popup-title',
    btnPrimary: 'something-wrong-popup-btn-yes',
  };

  return (
    <>
      <Modal show={show} dialogClassName={'modal-dialog modal-md'}>
        <Modal.Header>
          <Modal.Title id={elementID?.title}>{t('Common.Label.SomethingWentWrong')}</Modal.Title>
        </Modal.Header>

        <Modal.Body>{t('Common.Label.SomethingWentWrongDescription')}</Modal.Body>

        <Modal.Footer>
          <div className="float-right">
            <Button
              variant="primary"
              id={elementID?.btnPrimary}
              onClick={() => {
                if (onClose) {
                  onClose();
                }
              }}
            >
              {t('Common.Button.Close')}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
